import { getGroundLoyaltyProgram } from "@capone/common";

export const getCarLoyaltyProgramName = (vendorCode: string): string | undefined =>
  getGroundLoyaltyProgram(vendorCode)?.loyaltyProgramName;
